import { ToastProgrammatic as Toast } from 'buefy'

// The toast shows its message as HTML. An error is plain text: it can be a message from the
// API, or iyzico's passed on by it, so it is escaped
const escapeHtml = text =>
  String(text).replace(
    /[&<>"']/g,
    char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char])
  )

const show = config => {
  const baseConfig = { duration: 2000 }
  Toast.open(Object.assign(baseConfig, config))
}

const ToastService = {
  open: config => {
    show(config)
  },
  success: message => {
    const baseConfig = { type: 'is-success' }
    show(Object.assign(baseConfig, { message }))
  },
  error: message => {
    const baseConfig = { type: 'is-danger' }
    show(Object.assign(baseConfig, { message: escapeHtml(message) }))
  }
}

export default ToastService
